import type { BaseLogger } from '../types'

/**
 * @class NoopAdapter - silent logger that intentionally does nothing
 *
 * Useful for unit tests or environments where logging should be suppressed
 */
export class NoopAdapter implements BaseLogger {
  error(): void {}
  log(): void {}
  warn(): void {}
  info(): void {}
  debug(): void {}
}
